import React from "react"
import types from "prop-types"
import clsx from "clsx"
import { useSelector } from "react-redux"
import { store } from "store"
import { Draggable } from "@hello-pangea/dnd"
import Switch from "shared/Switch"
import { DragGripHandleIcon } from "shared/icons"
import { isColumnVisible, setColumnVisible, setColumnHidden } from "reduxSlices/taskTableSlice"

const Column = ({ label, index, value }) => {
  const checked = useSelector(isColumnVisible(value))

  const toggleColumnVisibility = () => {
    const updateFunction = checked ? setColumnHidden : setColumnVisible

    store.dispatch(updateFunction(value))
  }

  return (
    <Draggable draggableId={value} index={index}>
      {
        (dragProvided) => (
          <div
            ref={dragProvided.innerRef}
            className="flex-center"
            {...dragProvided.draggableProps}
          >
            <DragGripHandleIcon dragProvided={dragProvided} />
            <div className={clsx(
              "flex-center flex-grow",
              "font-medium text-sm",
              "sidebar-border-wrap",
            )}
            >
              { label }
              <Switch
                checked={checked}
                onChange={toggleColumnVisibility}
              />
            </div>
          </div>
        )
      }
    </Draggable>
  )
}

Column.propTypes = {
  label: types.string.isRequired,
  index: types.number.isRequired,
  value: types.string.isRequired,
}

export default Column
